import React from 'react';
import { Link  } from 'react-router-dom';
import { useLanguage } from '../../Contexts/LanguageContext';
import './DownloadSection.scss';
const DownloadSection = () => {
  const { getLanguageData } = useLanguage();
const data = getLanguageData();

  const downloadContent = data.downloadSection.content;

  return (
    <>      
      <div className="section-spacing download-section">
          <div className="download-container">
            <div className="phone">
              <img src='/Assets/images/JLR-INSTALL.gif' alt="" />              
            </div>
            <div className="download-content">
              <h4>{downloadContent.downloadNow}</h4>
              <h2>{downloadContent.autoInspection}</h2>
              <p>{downloadContent.description}</p>
              <ul className="download-store">
                <li>
                  <Link to="https://apps.apple.com/ca/app/auto-inspection/id6447352451" target="_blank" rel="noopener noreferrer">
                    <img src='/Assets/images/app-store.svg' alt="" />
                  </Link>
                </li>
                <li>
                  <Link to="https://play.google.com/store/apps/details?id=com.focalx.inspection&hl=da&gl=US"  target="_blank" rel="noopener noreferrer">
                    <img src='/Assets/images/google-play.svg' alt="" />
                  </Link>
                </li>
                {/* <li>
                  <Link to="/" target="_blank" rel="noopener noreferrer">
                    <img src='/Assets/images/app-gallery.svg' alt="" />
                  </Link>
                </li>
                <li>
                  <Link to="/" target="_blank" rel="noopener noreferrer">
                    <img src='/Assets/images/oppo-store.svg' alt="" />
                  </Link>
                </li> */}
              </ul>
              <div className='qr-code'>
                <img src='/Assets/images/qr-code.svg' alt="" />
              </div>
            </div>
          </div>
        </div>
    </>
  );
};

export default DownloadSection;
